import DropDown from './components/Dropdown.vue'
import Expiry from './components/Expiry.vue'
import GoogleMaps from './components/GoogleMaps.vue'
import Loading from './components/Loading.vue'
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
	 Vue.component('drop-down', DropDown)
	 Vue.component('expiry', Expiry)
	 Vue.component('google-maps', GoogleMaps)
	 Vue.component('loading', Loading)
  }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/globalComponents.js